<template>
  <div class="carousel-card-plan-container mdn-Text">
    <div class="carousel-card-offer-tab-container" v-if="isPromotionActive">
      <div class="carousel-card-offer-tab">
        <span>{{ renderPromotionLabel }}</span>
      </div>
    </div>
    <div v-else class="carousel-card-black-friday-tab-container" />
    <div class="mdn-CardInstitutional--default card mdn-Text">
      <PlanTitle
        :text="`${plan.franchise + plan.bonus}GB`"
        class="plan-title-container"
      />
      <hr class="mdn-Divider mdn-Divider--horizontal mdn-Divider--default" />
      <PlanDescription :text="plan.name" class="plan-description-container" />
      <CardCommon :plan="plan" />
      <PlanSubtitle :text="plan.includeTitle" class="pb-2" />
      <div
        v-if="plan.skeelo"
        v-on:click="openInfo(plan)"
        class="skeelo w-100"
        tabindex="0"
        :title="String($t('accessibilityTexts.title.cardPlan.skeelo'))"
        @keyup.enter="openInfo(plan)"
      >
        <div
          style="display: flex; justify-content: space-between; cursor: pointer"
        >
          <div style="display: flex; align-items: center">
            <img
              style="width: 40px"
              src="https://mondrian.claro.com.br/brands/app/partners/72px-default/skeelo.svg"
              alt="Skeelo"
              title="Skeelo"
            />
            <p
              v-if="plan.id === '929d4daa-b0cb-4be9-9eba-10ba530c2535'"
              style="margin-top: 15px; margin-left: 15px"
            >
              Skeelo light
            </p>
            <p v-else style="margin-top: 15px; margin-left: 15px">Skeelo</p>
          </div>
          <span
            style="color: red; margin-top: 10px"
            class="mdn-Icon-informacao mdn-Icon--md"
          ></span>
        </div>
        <div v-if="info">
          <br />
          Livros digitais by Skeelo é uma plataforma de leitura com eBooks mais
          vendidos nas livrarias diretamente no seu celular, um novo ebook por
          mês.
        </div>
      </div>
      <Cupom
        :catalog-id="plan.catalogId"
        :planId="plan.id"
        :coupon-code="plan.coupon"
        :franchise="plan.franchise"
        :bonus="plan.bonus"
        @success="onSuccessCupom"
        v-if="plan.coupon"
        class="mt-3 w-100"
      />
      <div class="plan-values-list mt-3">
        <p>
          <span>Valor do plano:</span>
          <span class="plan-price"
            >R$ {{ String(plan.price).replace(".", ",") }}</span
          >
        </p>
        <p v-if="!couponOff">
          <span>Valor do desconto:</span>
          <span class="plan-discount"
            >- R$ {{ discounts.replace(".", ",") }}</span
          >
        </p>
      </div>
      <div class="plan-first-month mdn-Text" v-if="off">
        <p>
          <span>R$</span>
          {{ off < 0 ? "0,00" : off.replace(".", ",") }}
        </p>
        <p class="plan-first-month-warning">no primeiro mês</p>
      </div>
      <div class="plan-buttons">
        <button
          class="mdn-Button mdn-Button--primary mdn-Button--lg mdn-Button--block"
          :title="mountPlanTitle(plan)"
          @click="$emit('register', { plan, couponSelected })"
          :id="plan.id"
        >
          Quero esse
        </button>
      </div>
      <div class="plan-details">
        <button
          type="button"
          class="plan-details-btn-link"
          @click.prevent="openDetails(plan)"
          :title="String($t('accessibilityTexts.title.cardPlan.moreDetails'))"
        >
          Mais detalhes
          <i class="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import { Component } from "vue-property-decorator";

import Cupom from "@/components/core/Cupom.vue";
import PlanDialog from "@/components/common/PlanDialog/index.vue";
import { showSkeelo } from "@/utils/Skeelo";
import PlanTitle from "@/components/PlanTitle/index.vue";
import PlanDescription from "@/components/PlanDescription/index.vue";
import PlanSubtitle from "@/components/PlanSubtitle/index.vue";
import { mixins } from "vue-class-component";
import { CardPlanMixin } from "@/mixins/CardPlan.mixin";
import CardCommon from "@/components/Swiper/CardCommon.vue";

@Component({
  name: "CarouselCardPlan",
  methods: { showSkeelo },
  components: {
    CardCommon,
    Cupom,
    PlanDialog,
    PlanTitle,
    PlanDescription,
    PlanSubtitle,
  },
})
export default class CarouselCardPlan extends mixins(Vue, CardPlanMixin) {}
</script>

<style lang="scss" scoped>
.carousel-card-plan-container {
  font-family: var(--font-family-base) !important;
  margin: 15px 0 0 0;

  .carousel-card-offer-tab-container {
    width: 153px;
    height: 46px;
    margin-bottom: -10px;

    .carousel-card-offer-tab {
      width: 153px;
      height: 46px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #da291c;
      border-radius: 8px 8px 0 0;
      padding: 0 5px;

      span {
        margin-top: -6px;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
      }
    }
  }

  .carousel-card-black-friday-tab-container {
    width: 200px;
    height: 46px;
    margin-bottom: -10px;

    .carousel-card-black-friday-tab {
      width: 200px;
      height: 46px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #000000;
      border-radius: 8px 8px 0px 0px;

      span {
        margin-top: -6px;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
      }
    }
  }

  .mdn-Icon-informacao {
    &:before {
      color: #d4d7de;
    }
  }

  .card {
    width: 310px;
    box-sizing: border-box;
    min-height: 600px;
    display: flex;
    flex-wrap: wrap;

    background: #f8f8f8;
    border: 1px solid #d4d7de;
    border-radius: 8px;

    .plan-title-container {
      width: 40%;
    }

    .plan-description-container {
      width: 60%;
    }

    .plan-total {
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;

      h3 {
        font-weight: 700;
        font-size: 48px;
        line-height: 20px;

        color: #da291c;

        i {
          color: #da291c;
        }
      }
    }

    .plan-divider-container {
      margin: 0 auto 21px auto;
      padding: 0;
      display: none;

      hr {
        height: 1px;
        padding: 0;
        margin: 0;
      }
    }

    .plan-description {
      p {
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;

        color: #000000;
      }
    }

    .plan-sub-title {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      margin: 14px 0 0 0;

      color: #000000;
    }

    .skeelo {
      background: #fff;
      border: 1px solid #ccc;
      border-radius: var(--border-radius-xs);
      padding: 10px;
    }

    .plan-coupon {
      width: 100% !important;
      margin-top: 22px;

      .card-cupom {
        border: 1px solid #d4d7de !important;
        border-radius: 8px !important;
      }
    }

    .plan-values-list {
      p {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        padding: 0;
        margin: 0;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;

        color: #000000;

        .plan-price {
          font-weight: 700;
        }

        .plan-discount {
          color: #00850f;
        }
      }
    }

    .plan-first-month {
      width: 100%;
      margin-top: 28px;
      p {
        font-weight: 700;
        font-size: 48px;
        line-height: 30px;
        margin-bottom: 0;

        text-align: center;

        color: #da291c;

        span {
          font-size: 24px;
        }

        i {
          color: #da291c;
        }
      }

      .plan-first-month-warning {
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;

        text-align: center;

        color: #000000;
      }
    }

    .plan-buttons {
      width: 100%;
      margin-top: 23px;
    }

    .plan-details {
      display: none;
    }

    @media (min-width: 780px) {
      width: 320px;
      min-height: 755px;

      .plan-title-container {
        width: 100%;
      }

      .plan-description-container {
        width: 100%;
      }

      .plan-total {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        h3 {
          font-weight: 700;
          font-size: 48px;
          line-height: 20px;

          color: #da291c;

          i {
            color: #da291c;
          }
        }
      }

      .plan-divider-container {
        display: block;
      }

      .plan-values-list {
        width: 100%;
      }

      .plan-details {
        width: 100%;
        display: flex;
        justify-content: center;
        margin: 24px auto 19px auto;

        .plan-details-btn-link {
          width: 150px;
          height: 30px;
          display: flex;
          flex-wrap: nowrap;
          justify-content: center;
          padding: 0;

          text-align: center;
          font-weight: 500;
          font-size: 16px;
          line-height: 21px;
          color: #000000;

          i {
            height: 30px;
            padding: 0;
          }
        }
      }
    }
  }
}
</style>
